import { Contact } from "@/components/nyla/Contact";
import { SEO } from "@/components/nyla/SEO";

const contactJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: "https://nylaairwater.earth/" },
      { "@type": "ListItem", position: 2, name: "Contact", item: "https://nylaairwater.earth/contact" },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Nyla Air Water",
    image: "https://nylaairwater.earth/og-image.png",
    url: "https://nylaairwater.earth/",
    telephone: "+91-92979-79497",
    email: "contactus@nylaairwater.earth",
    priceRange: "$$$",
    address: {
      "@type": "PostalAddress",
      streetAddress: "Plot No. 78, 3rd Floor, CBI Colony, Kavuri Hills, Madhapur",
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500033",
      addressCountry: "IN",
    },
    areaServed: ["Hyderabad", "Bengaluru", "Mumbai", "Goa", "Delhi"],
    sameAs: [
      "https://www.instagram.com/nylaairwater",
      "https://www.facebook.com/nylaairwater",
      "https://www.linkedin.com/company/nylaairwater",
      "https://twitter.com/nylaairwater",
    ],
  },
];

export default function ContactPage() {
  return (
    <div data-testid="contact-page" className="pt-14">
      <SEO
        title="Partner With Us — Contact Nyla Air Water"
        description="Bring pure water to your table. Reach Nyla Air Water for luxury hospitality, premium retail, distribution, and press inquiries. Now serving Hyderabad, Bengaluru, Mumbai, Goa, Delhi."
        path="/contact"
        keywords="Nyla Air Water contact, luxury water distribution India, premium water partnership, Hyderabad water supplier, hospitality water brand"
        jsonLd={contactJsonLd}
      />
      <Contact />
    </div>
  );
}
